import React from 'react';
import { Helmet } from 'react-helmet';
import seo from './seoConfig';
import { PROJECT_URL } from '../config';

const PageLayout = ({ title, description, path, children }) => {
    const pageTitle = `Shodl - ${title || seo.home.title}`;
    const pageDescription = description || seo.home.description;
    const logoImage = "/shodl-logo-large.png";
    const isPath = path !== null && path !== undefined;

    let fullUrl = window.location.href;
    if (fullUrl.endsWith("/")) 
        fullUrl = fullUrl.slice(0, -1);
    
    return (
        <>
            <Helmet>
                <title>{pageTitle}</title>
                <meta name="description" content={pageDescription} />
                { 
                    isPath ?
                    <link rel="canonical" href={`${PROJECT_URL}${path}`} /> :
                    <meta name="robots" content="noindex, follow" />
                }

                {/* Open Graph */}
                <meta property="og:title" content={pageTitle} />
                <meta property="og:description" content={pageDescription} />
                <meta property="og:url" content={fullUrl} />
                <meta property="og:image" content={logoImage} />
                <meta property="og:type" content="website" />

                {/* Twitter */}
                <meta name="twitter:title" content={pageTitle} />
                <meta name="twitter:description" content={pageDescription} />
                <meta name="twitter:url" content={fullUrl} />
                <meta name="twitter:image" content={logoImage} />
                <meta name="twitter:card" content="summary_large_image" />
            </Helmet>
            <main>{children}</main>
        </>
    );
};

export default PageLayout;
